import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=2a3090e7&scoped=true&"
import script from "./Estadisticas.vue?vue&type=script&lang=js&"
export * from "./Estadisticas.vue?vue&type=script&lang=js&"
import style0 from "./Estadisticas.vue?vue&type=style&index=0&id=2a3090e7&scoped=true&lang=css&"
import style1 from "./Estadisticas.vue?vue&type=style&index=1&id=2a3090e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3090e7",
  null
  
)

export default component.exports